import { eventEmitter } from '@/event-bus'
import i18n from '@/i18n/i18n'
import TmksService from '@/services/admin/TmksService'
import { build_query, errorMessage } from '@/utilities/helpers'

const { t } = i18n.global

export const allowedIncludes = []
export const allowedFilters = ['order_id', 'payment_date_between', 'by_tmks_refund_status']
export const allowedSorts = ''

export const namespaced = true

export const state = {
  refunds: [],
  meta: {}
}

export const mutations = {
  SET_REFUNDS(state, data) {
    state.refunds = data.data
    state.meta = data.meta
  },
  SET_ORDER_TRANSACTIONS(state, params) {
    let row = state.refunds.find(refund => refund.id === params.orderId)
    
    if (!row) {
      return
    }
    
    row.sub = params.transactions
  }
}

export const actions = {
  getRefunds({ commit, dispatch }, query) {
    return new Promise((resolve, reject) => {
      let newQuery = build_query(query, allowedFilters)
      TmksService.getRefunds(newQuery)
        .then(response => {
          commit('SET_REFUNDS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          
          dispatch('notification/add', notification, {
            root: true
          })
          
          reject(err)
        })
    })
  },
  
  getOrderTransactions({ commit, dispatch }, orderId) {
    return new Promise((resolve, reject) => {
      TmksService.getOrderTransactions(orderId)
        .then(response => {
          commit('SET_ORDER_TRANSACTIONS', {
            orderId: orderId,
            transactions: response.data
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          
          dispatch('notification/add', notification, {
            root: true
          })
          
          reject(err)
        })
    })
  },

  toggleImportRefundsModal({ dispatch }) {
    eventEmitter.emit('toggle-import-tmks-refunds-modal-event')
  },
  
  importRefunds({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      TmksService.importRefunds(form)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.tmks.import_started')
          }
          
          dispatch('notification/add', notification, {
            root: true
          })
          
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.tmks.import_failed') + errorMessage(err)
          }
          
          dispatch('notification/add', notification, {
            root: true
          })
          
          reject(err)
        })
    })
  },
  
  exportRefunds({ dispatch }, query) {
    return new Promise((resolve, reject) => {
      delete query.by_tmks_refund_status
      let newQuery = build_query(query, allowedFilters)
      TmksService.exportRefunds(newQuery)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.tmks.export_started')
          }
          
          dispatch('notification/add', notification, {
            root: true
          })
          
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.tmks.export_failed') + errorMessage(err)
          }
          
          dispatch('notification/add', notification, {
            root: true
          })
          
          reject(err)
        })
    })
  }
}
